export const styles = {
  width: "100%",
  height: "calc(100vh - 64px)",
  backgroundColor: "#22304a",
};
